import React, { useState, useEffect, useRef  } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useNotifications } from '../../../../hooks/notifications/useNotifications';
import { useAuth } from '../../../../context/AuthContext';
import './sidebarDashboard.css';

export const SidebarDashboard = ({ imagePath, sidebarItems, isOpen, onClose, userRole }) => {
  const [activeItem, setActiveItem] = useState(null);
  const location = useLocation();
  const sidebarRef = useRef(null);
  const { userInfo } = useAuth();
    
  // Get notifications from hook
  const { notifications, unreadCount, fetchNotifications } = useNotifications(userInfo);
  
  // Calculate unread message count specifically (only count MESSAGE type notifications)
  const getUnreadMessageCount = () => {
    if (!notifications || notifications.length === 0) {
      return 0;
    }
    // Filter notifications to only count unread MESSAGE type notifications
    return notifications.filter(
      notification => !notification.isRead && notification.type === 'MESSAGE'
    ).length;
  };

  // Refresh notifications when navigating to a chat (inbox page with conversationId)
  useEffect(() => {
    // Check if we're on a chat page (path includes inbox and has conversationId)
    const isChatPage = location.pathname.includes('/inbox-empresa/') || 
                       location.pathname.includes('/inbox-empleado/');
    
    if (isChatPage) {
      // Refresh notifications after a short delay to ensure backend has processed
      const timer = setTimeout(() => {
        fetchNotifications();
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [location.pathname, fetchNotifications]); 

  // Filter sidebar items based on user role
  const filteredSidebarItems = sidebarItems.filter(item => {
    // If item has no requiredRole, show to everyone
    if (!item.requiredRole) {
      return true;
    }
    // If item has requiredRole, only show if user has that role
    const hasPermission = item.requiredRole === userRole;
    return hasPermission;
  });
  
  useEffect(() => {
    const foundItem = filteredSidebarItems.find(item => item.link === location.pathname);
    if (foundItem) {
      setActiveItem(foundItem.id);
    }
  }, [filteredSidebarItems, location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose(); 
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className={`sidebar-dashboard__container ${isOpen ? 'open' : ''}`}>
      {/* <img className="sidebar-dashboard__profile-image" src={imagePath} alt="Profile" /> */}
      
      <ul className={`sidebar-dashboard__menu-list ${isOpen ? 'open' : ''}`}>
        {filteredSidebarItems.map((item) => {
          const unreadMessageCount = getUnreadMessageCount();
          const showBadge = item.title === 'Mensajes' && unreadMessageCount > 0;
          
          return (
            <li key={item.id} className={`sidebar-dashboard__menu-item-container ${activeItem === item.id ? 'active' : ''}`} id="side-li">
              <NavLink
                to={item.link}
                onClick={() => {
                  setActiveItem(item.id);
                }}
              >
                <div className="sidebar-item__content">
                  <span className="sidebar-item__icon">{item.icon}</span>
                  <span className="sidebar-item__title">{item.title}</span>
                  {showBadge && (
                    <span className="sidebar-item__badge">
                      {unreadMessageCount > 99 ? '99+' : unreadMessageCount}
                    </span>
                  )}
                </div>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SidebarDashboard;
